/* INTEGY V501 — collection/search-only mobile filter drawer. */
/* ---- consolidated from integy-v466-mobile-filter-owner.js ---- */
/* INTEGY V466 — single-owner mobile filter drawer.
   Fixes overlapping duplicate sidebars, dead cloned search inputs, accordion
   state drift, and inaccessible filters on compact touch devices. */
(function () {
  'use strict';
  if (window.IntegyV501MobileFilterOwner) return;

  var root = document.documentElement;
  var body = document.body;
  var activePanel = null;
  var lastTrigger = null;
  var observerTimer = 0;
  var mobileQuery = window.matchMedia
    ? window.matchMedia('(max-width: 860px), (pointer: coarse) and (max-width: 989px)')
    : null;

  function isMobile() {
    return !!(mobileQuery && mobileQuery.matches);
  }

  function qs(selector, scope) {
    try { return (scope || document).querySelector(selector); } catch (error) { return null; }
  }

  function qsa(selector, scope) {
    try { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); } catch (error) { return []; }
  }

  function sidebars() {
    return qsa([
      'body.template-collection [data-productgrid-sidebar]',
      'body.template-collection .productgrid--sidebar',
      'body.template-search [data-productgrid-sidebar]',
      'body.template-search .productgrid--sidebar'
    ].join(',')).filter(function (panel, index, all) {
      return all.indexOf(panel) === index;
    });
  }

  function meaningful(panel) {
    return !!(panel && qs([
      'details',
      '[data-integy-v188-model-filter-list]',
      '[data-integy-v200-static-part-filter-list]',
      '.filter-item',
      '[data-filter-input]',
      'a[href*="/collections/"]'
    ].join(','), panel));
  }

  function scorePanel(panel) {
    var score = 0;
    if (!panel || !meaningful(panel)) return -10000;
    var outer = panel.closest ? panel.closest('.productgrid--outer,.productgrid--wrapper,.collection--section,.search--section') : null;
    if (outer && outer.offsetParent !== null) score += 100;
    if (panel.offsetParent !== null) score += 40;
    if (panel.closest && panel.closest('[hidden],[aria-hidden="true"]')) score -= 30;
    if (panel.querySelector('[data-integy-v188-model-filter-list]')) score += 8;
    if (panel.querySelector('[data-integy-v200-static-part-filter-list]')) score += 8;
    return score;
  }

  function choosePanel() {
    var candidates = sidebars().filter(meaningful);
    candidates.sort(function (a, b) { return scorePanel(b) - scorePanel(a); });
    return candidates[0] || null;
  }

  function filterRows(panel) {
    return qsa([
      '.integy-v427-filter-chip',
      '.integy-v426-filter-chip',
      '.integy-v201-static-filter-row',
      '.integy-v429-vehicle-filter-row',
      '.integy-v27-filter-chip',
      '[data-filter-input]',
      '.filter-item',
      '.collection-filters__filter-list-item'
    ].join(','), panel).filter(function (row, index, all) {
      return all.indexOf(row) === index && !row.closest('.integy-v466-filter-toolbar') && !row.matches('summary');
    });
  }

  function cleanRowText(row) {
    var label = qs('.integy-v201-filter-label,.integy-v188-model-filter__label,.integy-v187-model-filter__label,.filter-text', row);
    return String((label || row).textContent || '')
      .replace(/\(\s*\d+\s*\)/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function syncDetails(details) {
    if (!details) return;
    var summary = qs(':scope > summary', details);
    if (!summary) return;
    summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    var icon = qs('.integy-v466-details-icon', summary);
    if (!icon) {
      var candidate = qs(':scope > span[aria-hidden="true"]:last-child', summary);
      icon = candidate || document.createElement('span');
      icon.classList.add('integy-v466-details-icon');
      icon.setAttribute('aria-hidden', 'true');
      if (!candidate) summary.appendChild(icon);
    }
    icon.textContent = details.open ? '−' : '+';
  }

  function syncAllDetails(panel) {
    qsa('details', panel).forEach(syncDetails);
  }



  function filterContext(panel) {
    var path = String(location.pathname || '').toLowerCase();
    var hasModels = !!qs('[data-integy-v188-model-filter-list]', panel);
    var modelSpecific = hasModels && qsa('[data-integy-v188-model-filter-row][aria-current="page"],[data-integy-v188-model-filter-row].is-active', panel).length > 0;
    if (/all-rc-tools|rc-tools|tool-sets/.test(path)) return { placeholder: 'Search tool types or finishes', helper: 'Search tool types or finishes' };
    if (modelSpecific) return { placeholder: 'Search parts or colors', helper: 'Search parts or colors' };
    if (hasModels) return { placeholder: 'Search models or parts', helper: 'Search models or parts' };
    return { placeholder: 'Search filters', helper: 'Search available filters' };
  }

  function flattenAllGroups(panel) {
    if (!panel) return;
    qsa('details', panel).forEach(function (details) {
      details.open = true;
      details.setAttribute('open', '');
      details.setAttribute('data-integy-v520-flat-details', 'true');
      syncDetails(details);
    });
    qsa('.filter-item--toggle-more,[data-filter-show-more],[data-integy-v517-filter-more],[data-integy-v519-filter-more],[data-integy-v520-filter-more]', panel).forEach(function (node) {
      node.hidden = true;
      node.setAttribute('aria-hidden', 'true');
    });
    panel.classList.add('integy-v520-filter-panel-ready');
  }

  function updateActiveText(panel) {
    var host = qs('.integy-v466-filter-active', panel);
    if (!host) return;
    var selected = filterRows(panel).filter(function (row) {
      return row.classList.contains('is-active') ||
        row.classList.contains('integy-v31-checkbox-filter--active') ||
        row.getAttribute('aria-checked') === 'true' ||
        row.getAttribute('aria-pressed') === 'true' ||
        row.hasAttribute('data-filter-active');
    }).map(function (row) {
      return cleanRowText(row).replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
    }).filter(Boolean);
    host.textContent = selected.length
      ? 'Selected: ' + selected.slice(0, 3).join(' · ')
      : filterContext(panel).helper;
  }

  function applySearch(panel, rawValue) {
    if (!panel) return;
    var term = String(rawValue || '').trim().toLowerCase();
    var rows = filterRows(panel);
    var visibleCount = 0;

    rows.forEach(function (row) {
      var match = !term || cleanRowText(row).indexOf(term) !== -1;
      row.hidden = !match;
      row.classList.toggle('integy-v466-filter-search-hidden', !match);
      row.setAttribute('aria-hidden', match ? 'false' : 'true');
      if (match) visibleCount += 1;
    });

    qsa('details', panel).forEach(function (details) {
      var rowsInside = filterRows(details);
      if (!rowsInside.length) return;
      var any = rowsInside.some(function (row) { return !row.hidden; });
      details.hidden = !!(term && !any);
      details.classList.toggle('integy-v466-filter-group-empty', !!(term && !any));
      if (term && any) details.open = true;
      syncDetails(details);
    });

    var noResults = qs('.integy-v466-filter-no-results', panel);
    if (noResults) noResults.hidden = visibleCount !== 0;
    var count = qs('.integy-v466-filter-match-count', panel);
    if (count) count.textContent = term ? visibleCount + ' matching filter' + (visibleCount === 1 ? '' : 's') : '';
  }

  function removeLegacyChrome() {
    qsa([
      '.integy-v445-filter-backdrop',
      '.integy-v445-filter-close',
      '.integy-v444-filter-backdrop',
      '.integy-v444-filter-close',
      '.integy-v440-filter-backdrop',
      '.integy-v440-filter-close',
      '.integy-v436-filter-backdrop',
      '.integy-v436-filter-close'
    ].join(',')).forEach(function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
    qsa('.integy-v464-filter-toolbar').forEach(function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
  }

  function ensureToolbar(panel) {
    var toolbar = qs('.integy-v466-filter-toolbar', panel);
    if (!toolbar) {
      toolbar = document.createElement('div');
      toolbar.className = 'integy-v466-filter-toolbar';
      toolbar.innerHTML = [
        '<div class="integy-v466-filter-toolbar-row">',
          '<strong>Filters</strong>',
          '<button type="button" class="integy-v466-filter-done" aria-label="Close filters">Close</button>',
        '</div>',
        '<label class="integy-v466-filter-search">',
          '<span class="visually-hidden">Search available filters</span>',
          '<input type="search" inputmode="search" autocomplete="off" autocapitalize="none" spellcheck="false" placeholder="Search models or parts">',
        '</label>',
        '<div class="integy-v466-filter-toolbar-meta">',
          '<span class="integy-v466-filter-active" aria-live="polite"></span>',
          '<span class="integy-v466-filter-match-count" aria-live="polite"></span>',
        '</div>',
        '<p class="integy-v466-filter-no-results" hidden>No matching filters.</p>'
      ].join('');
      panel.insertBefore(toolbar, panel.firstChild);
    }
    var context = filterContext(panel);
    var searchInput = qs('.integy-v466-filter-search input', toolbar);
    if (searchInput) searchInput.setAttribute('placeholder', context.placeholder);
    updateActiveText(panel);
    return toolbar;
  }

  function decoratePanel(panel) {
    if (!panel) return;
    removeLegacyChrome();
    ensureToolbar(panel);
    qsa('details', panel).forEach(function (details) {
      if (details.dataset.integyV466Bound !== 'true') {
        details.dataset.integyV466Bound = 'true';
        details.addEventListener('toggle', function () { syncDetails(details); });
      }
      syncDetails(details);
    });
    flattenAllGroups(panel);
    var input = qs('.integy-v466-filter-search input', panel);
    var context = filterContext(panel);
    if (input) input.setAttribute('placeholder', context.placeholder);
    applySearch(panel, input ? input.value : '');
  }

  function clearPanelClasses() {
    sidebars().forEach(function (panel) {
      panel.classList.remove('integy-v466-filter-panel-active', 'integy-v466-filter-panel-inactive');
      panel.removeAttribute('aria-modal');
      panel.removeAttribute('role');
      panel.removeAttribute('data-integy-v466-active-panel');
    });
  }

  function unlockPage() {
    if (!document.body) return;
    document.body.classList.remove('integy-v466-filter-lock', 'integy-v445-filter-lock', 'integy-v444-filter-lock');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('touch-action');
  }

  function closeFilter(options) {
    options = options || {};
    root.classList.remove('integy-v466-filter-open', 'integy-v445-filter-open', 'integy-v444-filter-open', 'integy-v440-filter-open', 'integy-v436-filter-open');
    qsa('.integy-v466-filter-backdrop').forEach(function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
    if (activePanel) activePanel.setAttribute('aria-hidden', isMobile() ? 'true' : 'false');
    clearPanelClasses();
    unlockPage();
    if (lastTrigger && lastTrigger.setAttribute) lastTrigger.setAttribute('aria-expanded', 'false');
    if (options.restoreFocus !== false && lastTrigger && document.contains(lastTrigger)) {
      try { lastTrigger.focus({ preventScroll: true }); } catch (error) { try { lastTrigger.focus(); } catch (ignored) {} }
    }
    activePanel = null;
    lastTrigger = null;
  }

  function openFilter(trigger) {
    if (!isMobile()) return false;
    closeFilter({ restoreFocus: false });
    removeLegacyChrome();

    var panel = choosePanel();
    if (!panel) return false;
    activePanel = panel;
    lastTrigger = trigger || document.activeElement;

    sidebars().forEach(function (candidate) {
      var isActive = candidate === panel;
      candidate.classList.toggle('integy-v466-filter-panel-active', isActive);
      candidate.classList.toggle('integy-v466-filter-panel-inactive', !isActive);
      candidate.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    panel.hidden = false;
    panel.removeAttribute('hidden');
    panel.setAttribute('data-integy-v466-active-panel', 'true');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Filter products');
    panel.scrollTop = 0;
    decoratePanel(panel);

    var hasOpen = qsa('details', panel).some(function (details) { return details.open && !details.hidden; });
    if (!hasOpen) {
      var first = qsa('details', panel).find(function (details) { return !details.hidden; });
      if (first) first.open = true;
    }
    syncAllDetails(panel);

    var backdrop = document.createElement('button');
    backdrop.type = 'button';
    backdrop.className = 'integy-v466-filter-backdrop';
    backdrop.setAttribute('aria-label', 'Close product filters');
    document.body.appendChild(backdrop);

    root.classList.add('integy-v466-filter-open');
    document.body.classList.add('integy-v466-filter-lock');
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';
    if (lastTrigger && lastTrigger.setAttribute) lastTrigger.setAttribute('aria-expanded', 'true');

    window.requestAnimationFrame(function () {
      var done = qs('.integy-v466-filter-done', panel);
      if (done) {
        try { done.focus({ preventScroll: true }); } catch (error) { try { done.focus(); } catch (ignored) {} }
      }
    });
    return true;
  }

  function focusable(panel) {
    return qsa('button:not([disabled]),a[href]:not([tabindex="-1"]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])', panel)
      .filter(function (node) { return !node.hidden && node.offsetParent !== null && node.getAttribute('aria-hidden') !== 'true'; });
  }

  /* Capture-phase ownership prevents theme-native and legacy drawer handlers from also opening. */
  window.addEventListener('click', function (event) {
    if (!isMobile()) return;
    var target = event.target;
    var trigger = target && target.closest ? target.closest('[data-productgrid-trigger-filters],.utils-filter-button') : null;
    if (!trigger || trigger.closest('[data-productgrid-sidebar],.productgrid--sidebar')) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openFilter(trigger);
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('.integy-v466-filter-done,.integy-v466-filter-backdrop')) {
      event.preventDefault();
      closeFilter({ restoreFocus: true });
      return;
    }
    if (root.classList.contains('integy-v466-filter-open')) {
      var link = target.closest('.integy-v466-filter-panel-active a[href]');
      if (link) closeFilter({ restoreFocus: false });
    }
  }, true);

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('.integy-v466-filter-search input')) return;
    var panel = input.closest('.productgrid--sidebar,[data-productgrid-sidebar]');
    applySearch(panel, input.value);
  });

  document.addEventListener('change', function (event) {
    if (!activePanel || !activePanel.contains(event.target)) return;
    window.setTimeout(function () { updateActiveText(activePanel); }, 0);
  });

  document.addEventListener('keydown', function (event) {
    if (!root.classList.contains('integy-v466-filter-open') || !activePanel) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeFilter({ restoreFocus: true });
      return;
    }
    if (event.key !== 'Tab') return;
    var nodes = focusable(activePanel);
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  function refreshOpenPanel() {
    observerTimer = 0;
    if (!root.classList.contains('integy-v466-filter-open')) return;
    if (!activePanel || !document.contains(activePanel)) {
      var trigger = lastTrigger;
      closeFilter({ restoreFocus: false });
      openFilter(trigger);
      return;
    }
    decoratePanel(activePanel);
  }

  function scheduleRefresh() {
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(refreshOpenPanel, 80);
  }

  ['integy:v429:filter-rendered', 'integy:v429:vehicle-filtered', 'integy:v307:filter-rendered', 'shopify:section:load'].forEach(function (name) {
    document.addEventListener(name, scheduleRefresh);
  });

  window.addEventListener('pageshow', function () { closeFilter({ restoreFocus: false }); }, { passive: true });
  window.addEventListener('orientationchange', function () { closeFilter({ restoreFocus: false }); }, { passive: true });
  window.addEventListener('resize', function () {
    if (!isMobile()) closeFilter({ restoreFocus: false });
  }, { passive: true });

  function boot() {
    body = document.body;
    closeFilter({ restoreFocus: false });
    if (window.MutationObserver && document.body) {
      new MutationObserver(function (mutations) {
        var relevant = mutations.some(function (mutation) {
          return mutation.addedNodes && mutation.addedNodes.length;
        });
        if (relevant) scheduleRefresh();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  window.IntegyV501MobileFilterOwner = window.IntegyV500MobileFilterOwner = window.IntegyV499MobileFilterOwner = window.IntegyV495MobileFilterOwner = true;
  window.IntegyV501MobileFilters = window.IntegyV500MobileFilters = window.IntegyV499MobileFilters = window.IntegyV495MobileFilters = {
    open: openFilter,
    close: closeFilter,
    applySearch: applySearch,
    refresh: scheduleRefresh
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());


;
